import React from "react";
import { Link } from "react-router-dom";
import Divider from "@/components/Divider";

const IMG1 = "https://images.unsplash.com/photo-1592457711340-2412dc07b733?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";
const IMG2 = "https://images.unsplash.com/photo-1604329760661-e71dc83f8f26?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";

export default function Philosophy() {
  return (
    <article className="bg-mizizi-cream">
      <header className="max-w-4xl mx-auto px-6 md:px-10 pt-24 md:pt-40 pb-16 text-center">
        <div className="overline text-mizizi-terracotta">The Philosophy</div>
        <h1 className="font-serif font-light text-5xl md:text-7xl mt-6 leading-none">Rooted, not staged.</h1>
      </header>

      <img src={IMG1} alt="" className="w-full max-w-6xl mx-auto aspect-[16/9] object-cover" />

      <section className="max-w-3xl mx-auto px-6 md:px-10 py-20 space-y-10 text-lg text-mizizi-charcoal/85 leading-relaxed">
        <p className="font-serif text-3xl md:text-4xl leading-snug text-mizizi-charcoal">
          Mizizi means <em className="text-mizizi-gold">roots</em>. Thirty plant-based recipes inspired by the flavors of home kitchens, roadside markets, and slow Sunday tables across Africa — drawing on grains, legumes, roots, greens, fruits, vegetables and the spice traditions that have carried the continent's cooking for generations.
        </p>
        <p>
          African food has often been photographed with either haste or exoticism. Mizizi photographs it the way any considered cuisine deserves — with restraint, with slow shadows, with the care given to a plate that took a full afternoon to make.
        </p>
        <p>
          The recipes are entirely plant-based. Across many African food traditions, grains, legumes, greens, roots, vegetables, fruits and spices have long formed the heart of everyday cooking. This is a kitchen without meat, without dairy, without eggs — set for plant-based diners, flexitarians, and curious omnivores alike. Nothing feels missing.
        </p>
        <p>
          Mizizi gives African plant-based cooking the craft, beauty and attention too often reserved for fine dining — while staying honest to the weeknight table, the Sunday gathering, and the kitchen you already have. Familiar ingredients treated with intention. Nothing here comes from a marketing meeting.
        </p>
      </section>

      <Divider />

      <section className="bg-mizizi-forest text-mizizi-cream py-24">
        <div className="max-w-4xl mx-auto px-6 md:px-10 grid md:grid-cols-3 gap-10 text-center">
          {[
            { t: "Rooted", d: "In grains, legumes, roots, greens and spice traditions carried across Africa." },
            { t: "Editorial", d: "Every recipe is prose. Every plate is composed like a photograph." },
            { t: "Gathering", d: "Written for the table you actually set, on the Tuesday you actually cook." },
          ].map((p, i) => (
            <div key={p.t} data-testid={`pillar-${i}`}>
              <div className="font-serif text-4xl text-mizizi-gold">{p.t}</div>
              <p className="mt-4 text-mizizi-cream/70">{p.d}</p>
            </div>
          ))}
        </div>
      </section>

      <img src={IMG2} alt="" className="w-full max-w-6xl mx-auto aspect-[16/9] object-cover mt-24" />

      <div className="text-center py-20">
        <Link to="/shop" data-testid="philosophy-cta" className="pill pill-primary">Take a Seat at the Table</Link>
      </div>
    </article>
  );
}
